import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';

const noNumbersRegex = /^([^0-9]*)$/;

const SimpleInputField = (
  {
    name,
    defaultValue,
    label,
    type,
    autoComplete,
    error,
    helperText,
    required,
    readOnly,
    loading,
    validate = null,
    disabled,
    setExternalValue = undefined,
    lettersOnly = false,
    upperCase = false,
    ...rest
  },
) => {
  const [ value, setValue ] = useState('');

  useEffect(() => {
    if ('' !== defaultValue && !defaultValue) {
      return;
    }
    setValue(defaultValue);

    if (setExternalValue !== undefined) {
      setExternalValue(defaultValue);
    }
  }, [ defaultValue ]);

  const isPostalCode = 'Postal Code' === label || 'Τ. Κ.' === label;

  const { t } = useTranslation();

  return (
    <>
      <FormControl
        size='small'
        fullWidth
        error={ error }
        disabled={ disabled }
        variant='outlined'
        style={ { marginTop: '18px' } }
      >
        <InputLabel
          color='secondary'
          disabled={ !!readOnly || disabled }
          shrink
          style={ { fontSize: '16px', fontWeight: 500, transform: 'translate(0px, -18px) scale(1)' } }
          id={ `${ name }-label` }
          htmlFor={ `${ name }-input` }
        >
          { `${ label }${ (required && !disabled) ? ' *' : '' }` }
        </InputLabel>
        <OutlinedInput
          id={ `${ name }-input` }
          aria-labelledby={ `${ name }-label` }
          disabled={ !!readOnly || disabled }
          color='secondary'
          margin='dense'
          value={ value }
          inputProps={ { style: { textTransform: upperCase ? 'uppercase' : 'none' } } }
          onChange={ (e) => {
            if (lettersOnly && !noNumbersRegex.test(e.target.value)) {
              return;
            }

            if (error && null !== validate) {
              validate(e.target.value);
            }

            if (setExternalValue !== undefined) {
              setExternalValue(e.target.value);
            }

            setValue(e.target.value);
          } }
          type={ isPostalCode ? 'number' : type }
          name={ name }
          autoComplete={ autoComplete }
          endAdornment={ (
            <>
              {loading ? <CircularProgress color='inherit' size={ 20 } /> : null}
              {rest?.InputProps?.endAdornment ? rest.InputProps.endAdornment : null}
            </>
          ) }
          { ...rest }
        />
      </FormControl>
      { error && (
        <FormControl>
          <FormHelperText margin='dense' error>
            { t(helperText) }
          </FormHelperText>
        </FormControl>
      ) }

    </>
  );
};

SimpleInputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  loading: PropTypes.bool,
};

SimpleInputField.defaultProps = {
  defaultValue: '',
  type: 'text',
  autoComplete: null,
  error: false,
  helperText: null,
  required: false,
  readOnly: false,
  loading: false,
};

export default SimpleInputField;
